import React from "react";

export default function UploadButton({ fileName, value }) {
  return (
    <div className="upload-button">
      {fileName || (
        <svg width="50pt" height="50pt" viewBox="0 0 50 50" version="1.1">
          <g id="surface38892">
            <path
              style={{
                stroke: "none",
                fillRule: "nonzero",
                fill: "rgb(100%,100%,100%)",
                fillOpacity: 1,
              }}
              d="M 43 32.769531 L 43 15.601562 L 29.398438 2 L 7 2 L 7 48 L 38 48 L 38 50 L 45 50 L 45 41 L 50 41 Z M 30 5.398438 L 39.585938 14.984375 L 30 14.984375 Z M 13 22 L 33 22 L 33 24 L 13 24 Z M 13 28 L 29 28 L 29 30 L 13 30 Z M 13 34 L 33 34 L 33 36 L 13 36 Z M 43 39 L 43 48 L 40 48 L 40 39 L 37.398438 39 L 41.496094 34 L 45.601562 39 Z M 43 39 "
            />
          </g>
        </svg>
      )}
    </div>
  );
}
